import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Cover } from '../';

export class Suggestions extends Component {
  static propTypes = {
    title: PropTypes.string,
    allCovers: PropTypes.array,
    children: PropTypes.any
  };


  render() {
    const allCovers = this.props.allCovers.map((cov, i) => (
      <section className="column is-one-fifth-tablet is-half-mobile" key={'cover_' + i}>
        <Cover cover={cov} />
      </section>
    ));

    return (
      <section className="column is-11 has-text-white" style={{ display: this.props.suggestionDisplay }}>
        <section className="columns is-variable is-1 is-multiline is-mobile">
          <div className="column is-full">
            {this.props.children}
          </div>
          {allCovers}
        </section>
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Suggestions/Suggestions.js